import { useRef, useState } from "react";
import { toast } from "sonner";
import { Paperclip, X, Loader2, FileText } from "lucide-react";
import { api, API_BASE as API } from "../lib/api";

export const attUrl = (id) => `${API}/support/attachments/${id}`;

export const AttList = ({ items, light }) => (!items?.length ? null : (
  <div className="mt-1.5 flex flex-wrap gap-1.5" data-testid="support-msg-atts">
    {items.map((a) => (a.content_type || "").startsWith("image/") ? (
      <a key={a.id} href={attUrl(a.id)} target="_blank" rel="noreferrer" data-testid={`support-att-${a.id}`}>
        <img src={attUrl(a.id)} alt={a.name} className="h-20 w-20 rounded-lg border border-white/40 object-cover" />
      </a>
    ) : (
      <a key={a.id} href={attUrl(a.id)} target="_blank" rel="noreferrer" data-testid={`support-att-${a.id}`}
        className={`inline-flex max-w-[160px] items-center gap-1 rounded-lg px-2 py-1 text-[11px] ${light ? "bg-white/20 text-white" : "bg-white text-slate-700 border border-slate-200"}`}>
        <FileText className="h-3.5 w-3.5 shrink-0" /><span className="truncate">{a.name}</span>
      </a>
    ))}
  </div>
));

export const AttachPicker = ({ value, onChange, testid = "support-attach" }) => {
  const [busy, setBusy] = useState(false);
  const ref = useRef();
  const pick = async (files) => {
    const list = [...(files || [])].slice(0, 3 - value.length);
    if (!list.length) { if (files?.length) toast.warning("الحد الأقصى 3 ملفات"); return; }
    setBusy(true);
    try {
      const out = [];
      for (const f of list) {
        if (!(f.type.startsWith("image/") || f.type === "application/pdf")) { toast.warning(`${f.name}: المسموح صور أو PDF فقط`); continue; }
        if (f.size > 10 * 1024 * 1024) { toast.warning(`${f.name}: الحجم أكبر من 10 ميجا`); continue; }
        out.push(await api.uploadSupportAttachment(f));
      }
      onChange([...value, ...out]);
    } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر رفع الملف"); }
    finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <button type="button" onClick={() => ref.current?.click()} disabled={busy || value.length >= 3} data-testid={`${testid}-btn`}
        className="inline-flex items-center gap-1 rounded-lg border border-dashed border-slate-300 px-2 py-1 text-xs text-slate-600 hover:border-blue-400 hover:text-blue-600 disabled:opacity-50">
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Paperclip className="h-3.5 w-3.5" />} إرفاق صورة أو ملف ({value.length}/3)
      </button>
      <input ref={ref} type="file" multiple accept="image/*,application/pdf" className="hidden" onChange={(e) => pick(e.target.files)} data-testid={`${testid}-input`} />
      {value.map((a) => (
        <span key={a.id} className="inline-flex max-w-[140px] items-center gap-1 rounded-full bg-blue-50 px-2 py-0.5 text-[11px] text-blue-700" data-testid={`${testid}-chip`}>
          <span className="truncate">{a.name}</span>
          <button type="button" onClick={() => onChange(value.filter((x) => x.id !== a.id))}><X className="h-3 w-3" /></button>
        </span>
      ))}
    </div>
  );
};
